import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogComponent } from 'app/componentes/mat-dialog/mat-dialog.component';
import { EmpresaService } from 'app/services/vinculacion/empresa/empresa.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-empresa-contenido',
  templateUrl: './empresa-contenido.component.html',
  styleUrls: ['./empresa-contenido.component.scss']
})
export class EmpresaContenidoComponent implements OnInit {


  EmpresaForm = new FormGroup({
    contenido: new FormControl('', [Validators.required])
  });
  
  constructor(private servicioempresa: EmpresaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    ) { }

  ngOnInit(): void {
    this.obtenerDatos()
  }


  //VERIFICAMOS SI EL USUARIO VA A SALIR DE LA RUTA  CON DATOS EN EL FORMULARIO
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.EmpresaForm.dirty) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          message: ' ¿ Desea salir sin guardar los cambios ? ',
          buttonText: {
            ok: 'Aceptar',
            cancel: 'Cancelar'
          }
        }
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }

  }

  //AVISO TIPO SNACKBAR ANGULAR MATERIAL
  openSnackBar(message: string) {
    this.snackBar.open(message, "Aceptar", { duration: 2000 });
  }

  onChangeEvent($event) {

  }

  obtenerDatos = () => {
    this.servicioempresa.getEmpresaContenido(1).subscribe(response => {
      this.EmpresaForm.patchValue(response[0]);
      this.EmpresaForm.markAsPristine()
      this.EmpresaForm.markAllAsTouched()
    })
  }


  guardarDatos = () => {

    this.servicioempresa.actualizarEmpresaContenido(1, this.EmpresaForm.value).subscribe(response => {
      this.EmpresaForm.markAsPristine()
      this.EmpresaForm.markAllAsTouched()
      this.openSnackBar('REGISTRO ACTUALIZADO!');
      this.ngOnInit()
    })

  }

}
